import { Injectable, inject } from '@angular/core';

import { OnLoginNavigationProvider } from '@frontend/vanilla/core';

import { LoginIntegrationService } from './login-integration.service';

@Injectable()
export class LoginIntegrationNavigationProvider implements OnLoginNavigationProvider {
    private readonly loginInegrationService = inject(LoginIntegrationService);

    async onLoginNavigation(): Promise<any> {
        await this.loginInegrationService.init();

        return Promise.resolve();
    }
}
